import React from "react";

export const ArrowLeftTabIcon = React.memo(({color = 'var(--messenger-grey-1)'} : {color?: any}) => {
    return (
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.25 17.5L6.75 10L14.25 2.5" stroke="#212121" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
});